import React from "react";
import DataGrid from "react-data-grid";
import { twJoin } from "tailwind-merge";

import { useDataGridConfig } from "./hooks/useDataGridConfig";
import { useDataGridAdapter } from "./hooks/useDataGridAdapter";
import { Context } from "./hooks/useIsExpandedRow";

import type { DataGridProps } from "./types";

export function SupDataGrid<R extends object>(props: DataGridProps<R>) {
  const config = useDataGridConfig(props);
  const { columns, rows, sortColumns, noRowsFallback, expandedRows, rowClass, rowRenderer, rowHeight, rowKeyGetter, onColumnsReorder, onSortColumnsChange, onCellClick } =
    useDataGridAdapter(config);

  return (
    <Context.Provider value={expandedRows}>
      <DataGrid
        key={`${props.name}-${columns.length}`}
        className={twJoin("custom-scrollbar", config.className)}
        sortColumns={sortColumns}
        columns={columns}
        rows={rows}
        onColumnsReorder={onColumnsReorder}
        onSortColumnsChange={onSortColumnsChange}
        rowHeight={rowHeight}
        headerRowHeight={config.headerRowHeight}
        renderers={{ noRowsFallback, renderRow: rowRenderer }}
        enableVirtualization={config.enableVirtualization}
        onCellClick={onCellClick}
        rowKeyGetter={rowKeyGetter}
        onScroll={config.onScroll}
        rowClass={rowClass}
      />
    </Context.Provider>
  );
}
